import React, { useEffect, useState } from 'react';
import cx from 'classnames';

const RadioButton = ({ name = '', radioList = [], onChange, value, radioGroupClassName }) => {
    const [radioChecked, setRadioChecked] = useState();

    useEffect(() => {
        setRadioChecked(value);
    }, [value]);

    const handleRadioChange = e => {
        const { value } = e.target;
        setRadioChecked(value);
        onChange(value);
    };

    return (
        <>
            {radioList.map(({ label, value }, index) => {
                return (
                    <label key={value + index} className={cx('pnt-radio', radioGroupClassName)} htmlFor={value + index}>
                        <p>{label}</p>
                        <input
                            type={'radio'}
                            id={value + index}
                            value={value}
                            checked={radioChecked === value}
                            name={name}
                            onChange={handleRadioChange}
                        />
                    </label>
                );
            })}
        </>
    );
};

export default RadioButton;
